import { Data } from './data';

export class Categorie extends Data {

    chemin: string;
    description: string;
    fil: Categorie[];
    nom: string;
    parent: Categorie;
    descendant: number[];
    type_content: string;

    constructor() {
        super();
    }

    get formatType(): string {

        let result = '';

        if( this.type_content === 'article')
        result = 'Catégorie d\'articles';

        if( this.type_content === 'projet')
        result =  'Catégorie de projets';

        return result;

    }

    
    
   
  }